"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ticket_service_1 = require("../../../tickets/ticket.service");
var DriverReferenceCell = /** @class */ (function () {
    function DriverReferenceCell(ticketService) {
        this.ticketService = ticketService;
        this.value = '';
    }
    DriverReferenceCell.prototype.agInit = function (params) {
        this.params = params;
        this.gridApi = params.api;
    };
    DriverReferenceCell.prototype.ngAfterViewInit = function () { };
    DriverReferenceCell.prototype.getValue = function () {
        if (this.reference) {
            return this.reference.driverName;
        }
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        return row && row.data.driverName ? row.data.driverName : '';
    };
    DriverReferenceCell.prototype.isCancelBeforeStart = function () {
        return false;
    };
    DriverReferenceCell.prototype.isCancelAfterEnd = function () {
        return false;
    };
    DriverReferenceCell.prototype.isPopup = function () {
        return true;
    };
    DriverReferenceCell.prototype.onReferenceClicked = function (reference) {
        var _this = this;
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        this.ticketService.updateFieldReference(row.data.id, reference, 'driver').subscribe(function (ticket) {
            _this.reference = reference;
            row.setData(ticket);
            _this.gridApi.stopEditing();
        });
    };
    DriverReferenceCell.prototype.onReferenceClosed = function () {
        this.gridApi.stopEditing();
    };
    return DriverReferenceCell;
}());
exports.DriverReferenceCell = DriverReferenceCell;
